var _style, _defs, _path;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgYellowcircle = function SvgYellowcircle(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 65.59 65.59",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0hel{clip-path:url(#SVGID_2b_);fill:#FDB03C;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1a_",
    width: 65.59,
    height: 65.59
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2b_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1a_",
    style: {
      overflow: "visible"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0hel",
    d: "M32.79,0C14.69,0,0,14.68,0,32.8c0,18.1,14.69,32.79,32.79,32.79c18.12,0,32.79-14.69,32.79-32.79   C65.59,14.68,50.91,0,32.79,0 M32.79,54.9c-12.2,0-22.11-9.91-22.11-22.11c0-12.21,9.91-22.11,22.11-22.11   c12.21,0,22.11,9.9,22.11,22.11C54.9,45,45.01,54.9,32.79,54.9",
    fill: "#FDB03C"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgYellowcircle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/yellowcircle.ae66ecb6.svg";
export { ForwardRef as ReactComponent };